import React, { useState, useRef } from "react";
import Header from "../../components/Header/Header";
import PreLoginHeader from "../../components/PreLoginHeader/PreLoginHeader";
import Footer from "../../components/Footer/Footer";
import "./LabTestsPage.scss";
import { useNavigate } from "react-router-dom";
import useAlertUtils from "../../utils/common.utils";
import { uploadMultipartData } from "../../services/apiService";

function AddNewTest() {
  const token = localStorage.getItem("token");
  const fileInputRef = useRef(null);
  const navigate = useNavigate();
  const { alertError, alertSuccess } = useAlertUtils();

  const base64Url = token.split(".")[1];
  const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  const jsonPayload = decodeURIComponent(
    atob(base64)
      .split("")
      .map((c) => `%${("00" + c.charCodeAt(0).toString(16)).slice(-2)}`)
      .join("")
  );

  const decoded = JSON.parse(jsonPayload);

  const [formData, setFormData] = useState({
    userId: decoded.userId,
    testName: "",
    laboratoryName: "",
    laboratoryLocation: "",
    testFileUrl: null,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (!selectedFile) return;

    if (selectedFile.size > 25 * 1024 * 1024) {
      alertError("File exceeds 25MB size limit.");
      return;
    }

    setFormData((prev) => ({
      ...prev,
      testFileUrl: selectedFile,
    }));
    e.target.value = null;
  };

  const handleFileDrop = (e) => {
    e.preventDefault();
    const droppedFile = e.dataTransfer.files[0];
    if (!droppedFile) return;

    if (droppedFile.size > 25 * 1024 * 1024) {
      alertError("File exceeds 25MB size limit.");
      return;
    }

    setFormData((prev) => ({
      ...prev,
      testFileUrl: droppedFile,
    }));
  };

  const handleCancel = () => {
    setFormData({
      testName: "",
      laboratoryName: "",
      laboratoryLocation: "",
      testFileUrl: null,
    });
    navigate("/app/lab-tests");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await uploadMultipartData(
        "/api/test/add-labTest",
        formData
      );
      if (response?.success === true) {
        alertSuccess("Test Uploaded Successfully");
        navigate("/app/lab-tests");
      }
    } catch (error) {
      alertError("Error Uploading Test Data");
      setFormData({
        testName: "",
        laboratoryName: "",
        laboratoryLocation: "",
        testFileUrl: null,
      });
    }
  };

  return (
    <div className="appointment-page">
      {token ? <Header /> : <PreLoginHeader />}

      <div className="add-test-wrapper">
        <div className="breadcrumb">
          <span className="breadcrumb-main">Lab Test</span>
          <span className="breadcrumb-separator">/</span>
          <span className="breadcrumb-sub">Add New Test</span>
        </div>

        <form onSubmit={handleSubmit} className="form-container">
          <div style={{ paddingBottom: "25px" }} className="main_title">
            Add New Test
          </div>
          <div className="form-content">
            <div className="form-left">
              <label>Test Name</label>
              <input
                value={formData.testName}
                onChange={handleChange}
                type="text"
                placeholder="Enter test name"
                id="testName"
                name="testName"
              />

              <label>Laboratory Name</label>
              <input
                value={formData.laboratoryName}
                onChange={handleChange}
                type="text"
                placeholder="Enter laboratory name"
                id="laboratoryName"
                name="laboratoryName"
              />

              <label>Laboratory Location</label>
              <input
                value={formData.laboratoryLocation}
                onChange={handleChange}
                type="text"
                placeholder="Enter laboratory location"
                id="laboratoryLocation"
                name="laboratoryLocation"
              />
            </div>

            <div className="form-right">
              <div
                className="file-upload-box"
                onDragOver={(e) => e.preventDefault()}
                onDrop={handleFileDrop}
                onClick={() => fileInputRef.current.click()}
              >
                <div className="upload-icon">+</div>
                <p>
                  Drop your file(s) here or{" "}
                  <span
                    className="browse"
                    onClick={(e) => {
                      e.stopPropagation();
                      fileInputRef.current.click();
                    }}
                  >
                    browse
                  </span>
                </p>
                <p className="file-size">Max. file size 25 MB</p>
                <input
                  type="file"
                  ref={fileInputRef}
                  onChange={handleFileChange}
                  style={{ display: "none" }}
                />
              </div>
              {formData.testFileUrl !== null && (
                <div className="selected-files">
                  <div className="file-item">
                    <div className="file-details">
                      <div className="file-icon">📄</div>
                      <div className="file-meta">
                        <div className="file-name">
                          {formData.testFileUrl.name}
                        </div>
                        <div className="file-size">
                          {(formData.testFileUrl.size / (1024 * 1024)).toFixed(
                            1
                          )}{" "}
                          MB
                        </div>
                      </div>
                    </div>
                    <button
                      type="button"
                      className="file-remove-btn"
                      onClick={() => {
                        setFormData((prev) => ({
                          ...prev,
                          testFileUrl: null,
                        }));
                      }}
                    >
                      &times;
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>

          <div className="form-actions">
            <button type="button" className="cancel-btn" onClick={handleCancel}>
              Cancel
            </button>
            <button
              type="submit"
              className="btn btn-primary save-btn"
              disabled={
                !formData.testName ||
                !formData.laboratoryName ||
                !formData.laboratoryLocation ||
                formData.testFileUrl === null
              }
            >
              Save
            </button>
          </div>
        </form>
      </div>
      <Footer />
    </div>
  );
}

export default AddNewTest;
